'use client';
/* eslint-disable no-var */ /**
 * Классическая хэш-функция FNV (Fowler/Noll/Vo) с преобразованием к строке по основанию 36.
 *
 * Оптимальна согласно тестам:
 * https://github.com/bryc/code/blob/master/jshash/hashes/README.md
 * */ var fnv1aBMr36 = function(value) {
    return fnv1aBM(value).toString(36);
};
/**
 * Классическая хэш-функция FNV (Fowler/Noll/Vo) - "forced avalanche" модификация (Mulvey).
 *
 * Оптимальна согласно тестам:
 * https://github.com/bryc/code/blob/master/jshash/hashes/README.md
 *
 * */ var fnv1aBM = function(value) {
    /*  ' | 0' оптимизация для firefox, удваивает производительность. */ var hash = 2166136261 | 0;
    for(var i = 0; i < value.length; i++){
        hash = Math.imul(hash ^ value[i], 16777619);
    }
    hash += hash << 13;
    hash ^= hash >>> 7;
    hash += hash << 3;
    hash ^= hash >>> 17;
    hash += hash << 5;
    return hash >>> 0;
};

export { fnv1aBM, fnv1aBMr36 };
